export default {
  // Menu
  'menu.book': 'Corpus',
  'menu.search': 'Search',
  'menu.occurrence':'Co-occurrence',
  'menu.reuse': 'Text Reuse',
  'menu.diachronicngram':'Diachronic N-gram',
  'menu.frequency': 'Frequency',
  'menu.frequency.ngram': 'N-gram Count',
  'menu.frequency.word': 'Word Count',
  'menu.frequency.contrast': 'Diachronic Comparison',
  'menu.frequency.evolution': 'Linguistic Drift',
  'menu.about': 'About',
  // Book
  // Book Overview Dynamic
  'book.overview.dynamic.text_reuse': 'Text Reuse',
  'book.overview.dynamic.switch_on': 'On',
  'book.overview.dynamic.switch_off': 'Off',
  'book.overview.dynamic.author': 'Author: ',
  'book.overview.dynamic.editor': 'Editor: ',
  'book.overview.dynamic.publication_time': 'Publication Time: ',
  'book.overview.dynamic.recording_time': 'Recording Time: ',
  // Book Overview Card
  'book.overview.card.author': 'Author',
  'book.overview.card.time': 'Time',
  'book.overview.card.subject': 'Category',
  //'book.overview.card.subject': 'Subject',

  // Search
  // Search.SearchPage
  'search.search_page.tab_list.book': 'Book Result',
  'search.search_page.tab_list.content': 'Text Result',
  'search.search_page.tab_list.empty': ' ',
  // Search.AdvancedSearch
  'search.advanced_search.form.search_button': 'Search',
  'search.advanced_search.form.scope_constraint': 'Scope constraint',
  'search.advanced_search.form.scope_select_sentence': 'Sentence',
  'search.advanced_search.form.scope_select_paragraph': 'Paragraph',
  'search.advanced_search.form.scope_select_chapter': 'Chapter',
  'search.advanced_search.form.scope_select_book': 'Book',
  'search.advanced_search.form.search_scope_title': 'Search scope:',
  'search.advanced_search.form.search_scope_book_title': 'Book Title',
  'search.advanced_search.form.search_scope_chapter_title': 'Chapter Title',
  'search.advanced_search.form.search_scope_author': 'Author',
  'search.advanced_search.form.search_scope_full_text': 'Full Text',
  'search.advanced_search.form.search_mode_title': 'Search Mode: ',
  'search.advanced_search.form.search_mode_fuzzy': 'Fuzzy Search',
  'search.advanced_search.form.range_select_title': 'Scope Selection: ',
  // Search.AdvancedSearch.RangeSelect
  'search.advanced_search.range_select.category': 'Category',
  'search.advanced_search.range_select.time': 'Time',
  'search.advanced_search.range_select.select_placeholder': 'Select scope',
  // Search.AdvancedSearch.MySearch
  'search.advanced_search.my_search.select_all': 'Select All',
  // Search.Book
  'search.book.result.secondary_earch': 'Secondary Search: ',
  'search.book.result.visualization': 'Visualization: ',
  'search.book.result.book_search_result': 'Book Search Result: ',
  // Search.Book.BookResult
  //'search.book.book_result.category': 'Subject',
  'search.book.book_result.category': 'Category',
  'search.book.book_result.dynasty': 'Time',
  'search.book.book_result.total': 'Total {total} results',
  // Search.Book.BookResult.Card
  'search.book.book_result.card.author': 'Author: ',
  'search.book.book_result.card.time': 'Time: ',
  //'search.book.book_result.card.subject': 'Subject: ',
  'search.book.book_result.card.subject': 'Category: ',

  // Search.Content
  'search.content.result.secondary_earch': 'Secondary Search: ',
  'search.content.result.visualization': 'Visualization: ',
  'search.content.result.content_search_result': 'Content Search Result: ',
  'search.content.result.content_result.book_name': 'Book Name',
  'search.content.result.content_result.author': 'Author',
  'search.content.result.content_result.time': 'Time',
  //'search.content.result.content_result.subject': 'Subject',
  'search.content.result.content_result.subject': 'Category',
  'search.content.result.content_result.text': 'Text',

  // Search.QuadraticSearch
  'search.quadratic_search.input.placeholder': 'Search in the result',
  'search.quadratic_search.button.confirm': 'Confirm',
  // Search.QuadraticSearch.ResultRange
  'search.quadratic_search.result_range.in_result': 'Count in the ',
  'search.quadratic_search.result_range.in_result_sentence': 'sentence',
  'search.quadratic_search.result_range.in_result_paragraph': 'paragraph',
  'search.quadratic_search.result_range.in_result_chapter': 'chapter',
  'search.quadratic_search.result_range.in_result_book': 'book',
  'search.quadratic_search.result_range.in_result_statistics': ' of the result',
  // Search.VisualizedResult
  'search.visualized_result.time': 'Time',
  //'search.visualized_result.subject': 'Subject',
  'search.visualized_result.subject': 'Category',
  'search.visualized_result.top_k_words': 'TopK Words',
  'search.visualized_result.top_k_words.top': 'Top ',
  // Search.VisualizedResult.VisualDualAxes
  'search.visualized_result.visual_dual_axes.meta_count': 'Count',
  'search.visualized_result.visual_dual_axes.meta_frequency': 'Frequency',
  'search.visualized_result.visual_dual_axes.legend_count': 'Count',
  'search.visualized_result.visual_dual_axes.legend_frequency': 'Frequency(%)',
  'search.visualized_result.visual_dual_axes.book_meta_count': 'Count',
  // Search.VisualizedResult.WordCloudSelect
  'search.visualized_result.word_cloud_select.in_result': 'Count in the ',
  'search.visualized_result.word_cloud_select.in_result_sentence': 'sentence',
  'search.visualized_result.word_cloud_select.in_result_paragraph': 'paragraph',
  'search.visualized_result.word_cloud_select.in_result_chapter': 'chapter',
  'search.visualized_result.word_cloud_select.in_result_book': 'book',
  'search.visualized_result.word_cloud_select.in_result_statistics':
    ' of the result',
  'search.quadratic_search.result_range.in_paragraph_result': 'Count in the paragraph of the query',
  'search.quadratic_search.result_range.in_chapter_result': 'Count in the chapter of the query',
  'search.quadratic_search.result_range.in_book_result': 'Count in the book of the query',
  // Reuse
  //'reuse.range.select.category': 'Subject',
  'reuse.range.select.category': 'Category',
  'reuse.range.select.dynasty': 'Publication Time',
  'reuse.range.select.all': 'All',
  'reuse.range.select.placeholder': 'Please select books for analysis',
  'reuse.range.setting.select.analysis.books':
    'Select the target book: ',
  'reuse.range.setting.select.search.books': 'Select the analysis scope: ',//'Select books for text search: ',
  'reuse.range_setting': 'Scope Setting',
  'reuse.reuse_result': 'Reuse Result',
  'reuse.next': 'Next',
  'reuse.reselect': 'Reselect',
  'reuse.tab_book': 'Book',
  'reuse.tab_chapter': 'Chapter',
  'reuse.tab_sentence': 'Sentence',
  // Reuse.Book.BookReuse
  'reuse.book.book_reuse.scope_selection_1': 'Target book',
  'reuse.book.book_reuse.scope_selection_2': 'Analysis scope',
  'reuse.book.book_reuse.total_frequency': 'The total frequency is {total}',
  'reuse.book.book_reuse.arc_graph': 'Arc Graph',
  'reuse.book.book_reuse.arc_result': 'Reuse Result List',
  // Reuse.Chapter.ChapterReuse
  'reuse.chapter.chapter_reuse.book': 'Book',
  'reuse.chapter.chapter_reuse.select_book': 'Select a book for analysis',
  'reuse.chapter.chapter_reuse.total_reuse_freq':
    'The total frequency is {freq}',
  'reuse.chapter.chapter_reuse.total_reuse_freq_en':
    'The total reuse frequency is {freq}',
  // Reuse.Sentence
  //'reuse.sentence.alertMessage':'{selectedBook} has been reused {total} times in the selected corpus.',
  'reuse.sentence.alertMessage':
    'The total frequency is {total}',
  'reuse.sentence.title': 'Reuse Sentence: {titlelst}',
  'reuse.sentence.return': 'Return',
  'reuse.sentence.alert':
    'The total reuse frequency is {totalreuse} in all the books collected in this system',
  //'reuse.sentence.book': 'Analyzing book',
  'reuse.sentence.book': 'Book',
  // Frequency
  'Frequency.ngram.analysis_setting': 'Analysis Setting',
  'Frequency.ngram.statistical_range': 'Statistical Scope',
  'Frequency.ngram.analysis_condition_settings': 'Analysis Condition Settings',
  'Frequency.ngram.scope': 'Scope',
  'Frequency.ngram.analysis_granularity': 'Analysis Granularity',
  'Frequency.ngram.matching_dictionary': 'Dictionary Matching',
  'Frequency.ngram.chinese_dict': 'Chinese Dictionary',
  'Frequency.ngram.stopword_table': 'Stopwords',
  'Frequency.ngram.use_stopwords': 'Use Stopwords',
  'Frequency.ngram.edit_stopwords': 'Edit Stopwords',
  'Frequency.ngram.preset_table_selection': 'Preset Table Selection:',
  'Frequency.ngram.select_all': 'Select All',
  'Frequency.ngram.custom_stopwords': 'Custom Stopwords:',
  'Frequency.ngram.split_with_newline': 'Split with newline "\\n"',
  'Frequency.ngram.submit': 'Submit',
  'Frequency.ngram.statistics_list': 'Statistics List',
  'Frequency.ngram.unigram': 'unigram',
  'Frequency.ngram.bigram': 'bigram',
  'Frequency.ngram.trigram': 'trigram',
  'Frequency.ngram.4-gram': '4-gram',
  //'frequency.ngram.index': 'ID {index}',
  'frequency.ngram.index': 'ID',
  'frequency.ngram.word': 'Word',
  'frequency.ngram.count': 'Count',
  'frequency.ngram.ratio': 'Frequency‰',
  // Frequency.RangeSelectBar.RangeSelect
  'frequency.range_select_bar.range_select.category': 'Category',
  'frequency.range_select_bar.range_select.time': 'Time',
  'frequency.range_select_bar.range_select.time_log':'Record Time',
  'frequency.range_select_bar.range_select.select_all': 'Select All',
  'frequency.range_select_bar.range_select.placeholder':
    'Please select books for analysis',
  // Frequency.Word.WordPage
  'frequency.word.word_page.analysis_range_selection':
    'Analysis Scope Selection',
  'frequency.word.word_page.statistical_range': 'Statistical Scope',
  'frequency.word.word_page.dict_matching': 'Dictionary Matching',
  'frequency.word.word_page.stopwords': 'Stopwords',
  'frequency.word.word_page.use_stopwords': 'Use Stopwords',
  'frequency.word.word_page.modify_table': 'Edit Stopwords',
  'frequency.word.word_page.stopwords_setting': 'Stopwords Setting',
  'frequency.word.word_page.use_preset_stopwords': 'Use preset stopwords:',
  'frequency.word.word_page.custom_stopwords': 'Custom Stopwords:',
  'frequency.word.word_page.submit': 'Submit',
  'frequency.word.word_page.select_all': 'Select All',
  'frequency.word.word_page.analysis_list': 'Analysis List',
  'frequency.word.word_page.tooltip':
    '【note】Present the frequency of word usage and diachronic change trend.',
  'frequency.word.word_page.tooltip2':
    '【note】Allow users to customize the stopword table to filter the results.',
  'frequency.word.word_page.line_chart': 'Line Chart',
  'frequency.word.word_page.bar_chart': 'Bar Chart',
  'frequency.word.word_page.chinese_dict': 'Chinese Dictionary',
  'frequency.word.word_page.split_with_newline': 'Split with newline ',
  'frequency.word.word_page.split_with_newline2': '"\\n"',
  'frequency.word.word_page.split_with_newline3': ' to automatically segment',
  'frequency.word.word_page.id': 'ID',
  'frequency.word.word_page.word': 'Word',
  'frequency.word.word_page.count': 'Count',
  'frequency.word.word_page.frequency': 'Frequency (‰)',
  // Frequency.Contrast.WordPage
  'frequency.contrast.word_page.content':
    'Support inputting multiple words or phrases at the same time, and comparing the appearance frequency of different search terms in a specific time range.',
  'frequency.contrast.word_page.analysis_condition_setting':
    'Analysis Condition Setting',
  'frequency.contrast.word_page.analysis_vocabulary': 'Analysis Vocabulary',
  'frequency.contrast.word_page.input_vocabulary':
    'Up to 10 words, each word is not more than 10 characters',
  'frequency.contrast.word_page.statistics_range': 'Statistics Scope',
  'frequency.contrast.word_page.submit': 'Submit',
  'frequency.contrast.word_page.time_range': 'Time Scope',
  //'frequency.contrast.word_page.line_chart':
    //'Search Result - Time Series Line Chart',
  'frequency.contrast.word_page.publictime_chart': 'Time Series Line Chart - Publication time',
  'frequency.contrast.word_page.recordingtime_chart': 'Time Series Line Chart - Recording time',
  // About
  'about.lab_website': 'Lab Website: {labWebsite}',
  'about.supervisor': 'Supervisor',
  'about.supervisor.name': 'Jun Wang, Qi Su, Hao Yang',
  'about.platform.architecture': 'Platform Architecture and Algorithm Design',
  'about.platform.architecture.name': 'Siyu Duan',
  'about.platform.interaction': 'Platform Interaction Design',
  'about.platform.interaction.name': 'Jiachun Li',
  'about.platform.development': 'Platform Development',
  'about.platform.development.name': 'Ruixuan Luo, Xiaohan Bi',
  // Sentence
  'sentence.dynamic.id': 'ID',
  'sentence.dynamic.reuse': 'Reuse',
  'sentence.dynamic.source': 'Source',
  'sentence.dynamic.total_reuse':'The reuse of this sentence in all books collected by this system is as follows:',
  //  'The total reuse frequency is {totalReuse} in all books collected by this system',
};
